<template>
	<div>
		<p v-if="$tera.project.reviewerRegistered">
			The review will be registed on
			{{ $tera.project.reviewerRegistered }}.
		</p>
		<p v-if="$tera.project.reviewProtocolDate">
			This protocol was last registered on
			{{ ($tera.project.reviewProtocolDate.nullValue || $tera.project.reviewProtocolDate=='') ? 'Blank' : $tera.project.reviewProtocolDate }}.
		</p>

		<p v-if="$tera.project.ifCite">
			This review was designed with the help of the Evidence Review Accelerator
			(TERA) [cite:
			<a href="https://www.ncbi.nlm.nih.gov/pubmed/32004673" target="_blank">
				https://www.ncbi.nlm.nih.gov/pubmed/32004673 </a
			>].
		</p>
	</div>
</template>
<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputStudyInformation",
	mixins: [OutputMixin]
};
</script>
